import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import EventUpdateWillMount from "../../../Middleware/Middlewares/EventUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { Timeline } from "../../Partials/Timeline/Timeline";
import { Attachment } from "../../Partials/Attachment/Attachment";

import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';

class NoteUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_EVENT_UPDATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    EventUpdateWillMount,
    PreventPageLeave
  ];

  public state = {
    noteEntity: null,
    note: "",
    selectedEntityForNoteManuallyChanged: false,
    selectedEntityForNote: null,
    hasModifiedData: false,
    isSaving: false,
    openLeavePrompt: false,
    nextPath: "",
    anchorElNote: null,
    isNoteRemovePopupOpen: false,
    noteToDelete: null,
    createdBy: null,
    removed: false,
    events: [],
    fetchingEvents: true,
    attachments: [],
    amazonFolderName: "",
    isFetchingNote: true
  }

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);

    if (prevId !== id) {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
        payload: {
          eventId: id
        },
        onSuccess: (event: EventInterface) => {
          if (!event) {
            return this.redirectBack();
          }

          this.initializePage(event);
          this.fetchEntityEvents(id);
        },
        onError: this.redirectBack
      })
    }
  }

  public initializePage = (note: EventInterface) => {
    let state: any = {
      noteEntity: note,
      note: !!note && !!note.content && !!note.content.note ? note.content.note : "",
      removed: !!note ? note.removed : false,
      createdBy: !!note ? note.createdBy : null,
      attachments: !!note ?  note.attachments : [],
      isFetchingNote: false
    };

    if (!!note.property) {
      state.selectedEntityForNote = note.property;
    }

    if (!!note.unit) {
      state.selectedEntityForNote = note.unit;
    }

    if (!!note.contract) {
      state.selectedEntityForNote = note.contract;
    }

    if (!!note.company) {
      state.selectedEntityForNote = note.company;
    }

    if (!!note.person) {
      state.selectedEntityForNote = note.person;
    }

    if (!!note.charge) {
      state.selectedEntityForNote = note.charge;
    }

    if (!!note.payment) {
      state.selectedEntityForNote = note.payment;
    }

    if (!!note.event) {
      state.selectedEntityForNote = note.event;
    }

    this.setState({...state}, () => {
      this.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
      });
    });
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        refersToEventId: entityId,
        removed: 0,
      },
      onSuccess: data => {
        this.setState({events: [...data.events], fetchingEvents: false});
      }
    });
  }

  public save = () => {
    const payload: any = {
      id: !!this.state.noteEntity && this.state.noteEntity.id,
      content: {
        note: this.state.note
      },
      eventTypeId: 17, // note
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {...payload},
        onSuccess: () => {
          if (this.state.nextPath) {
            return this.redirect(this.state.nextPath);
          }
          
          this.redirectBack();
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    })
  }

  protected openNoteMenu = (event: any, note): void => {
    this.setState({
      noteEntity: note,
      anchorElNote: event.currentTarget
    });
  }

  protected closeNoteMenu = (): void => {
    this.setState({
      anchorElNote: null
    });
  }

  public deleteNote = (note) => {
    this.setState({
      isSaving: true
    })

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: note
      },
      onSuccess: () => {
        this.setState({
          isSaving: false,
          hasModifiedData: false
        }, this.redirectBack)
      },
      onError: () => {
        this.setState({
          isSaving: false
        })
      }
    });
  }

  public render() {
    // const person = this.props.app.persons.filter((person: PersonInterface) => person.id === this.state.createdBy)[0];

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("note")}</h1>
              <div className="button-container-small">
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      style={{marginRight: "20px"}}
                      disabled={this.state.isSaving}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={!this.state.hasModifiedData ? this.redirectBack : this.save}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
                {
                  <div className="three-dot-entity-menu">
                    <IconButton
                      onClick={e => this.openNoteMenu(e, this.state.noteEntity)}
                    >
                      <div className="icon icon-ic-more-vert"></div>
                    </IconButton>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorElNote}
                      open={Boolean(this.state.anchorElNote)}
                      onClose={this.closeNoteMenu}
                      disableAutoFocusItem={true}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                      }}
                      getContentAnchorEl={null}
                    >
                      <MenuItem
                        className="delete-action"
                        onClick={() => {
                          this.setState({
                            isNoteRemovePopupOpen: true,
                            noteToDelete: this.state.noteEntity,
                            anchorElNote: null
                          })
                        }}
                      >
                        <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                      </MenuItem>
                    </Menu>
                  </div>
                }
              </div>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                {
                  this.state.isFetchingNote && (
                    <div style={{position: "relative", height: "60px"}}>
                      <div className="component-spinner-wrapper">
                        <CircularProgress />
                      </div>
                    </div>
                  )
                }

                {
                  !this.state.isFetchingNote && (
                    <Card className="card">
                      {this.state.selectedEntityForNote && (
                        <div className="read-only-wrapper">
                          <div style={{color: "gray", fontSize: "14px", marginRight: "5px"}}>
                            {this.trans("page/noteupdate-hint/notefor", {entity: this.state.selectedEntityForNote.nameOfEntity})}
                          </div>
                          <div className="margin-wrapper">
                            <div
                              className="link-to-entity"
                              onClick={() => this.redirect(`/app/${this.state.selectedEntityForNote.nameForUrl}/update/${this.state.selectedEntityForNote.id}`)}>
                              {this.state.selectedEntityForNote && this.state.selectedEntityForNote.displayName}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* {this.state.createdBy &&
                        <div className="read-only-wrapper" style={{marginTop: "0px", paddingTop: "0px"}}>
                          <div style={{color: "gray", fontSize: "14px", marginRight: "5px"}}>
                            {`${this.trans("registered-by")}: `}
                          </div>
                          <div className="margin-wrapper">
                            <div className="link-to-entity" onClick={() => this.redirect(`/app/user/update/${this.state.createdBy}`)}>
                              {person && person.displayName}
                            </div>
                          </div>
                        </div>
                      } */}

                      <div className="row">
                        <div className="grid"></div>
                        <div className="grid">
                          <TextField
                            autoComplete="off"
                            className="form-element full-size scroll-to-note"
                            type="text"
                            multiline
                            rowsMax="25"
                            label={this.state.note.length > 0 ? this.trans("note") : this.trans("type-a-note")}
                            value={this.state.note}
                            onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                            autoFocus={true}
                            variant="standard"
                            error={!!this.getErrorFor("note")}
                            />
                            {!!this.getErrorFor("note") && <div className="component-error-text">{this.getErrorFor("note")}</div>}
                        </div>
                      </div>
                    </Card>
                  )
                }

              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("shared-attachments-for-note")}
                amazonFolderName={this.state.amazonFolderName}
                relation="eventId"
                entity={this.state.noteEntity}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                updateParentState={attachments => this.setState({attachments: attachments})}
                disabled={this.state.removed}
                attachments={this.state.attachments}
              />
            </div>
          </div>

          { this.isBeta() && 
            <Timeline
              {...this.props}
              relations={{ refersToEventId: this.state.noteEntity && this.state.noteEntity.id }}
              entityEvents={this.state.events}
              fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.noteEntity && this.state.noteEntity.id)}
              fetchingEvents={this.state.fetchingEvents}
            />
          }
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-note")}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isNoteRemovePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isTaskRemovePopupOpen: false }); }}
          onSave={() => { this.setState({ isTaskRemovePopupOpen: false }, () => this.deleteNote(this.state.noteEntity)); }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.eventUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  NoteUpdate
);